export var ListType;
(function (ListType) {
    ListType["Array"] = "array";
    ListType["Set"] = "set";
    ListType["Map"] = "map";
    ListType["Object"] = "object";
    ListType["NoList"] = "noList";
    ListType["Iterator"] = "iterator";
})(ListType || (ListType = {}));
//# sourceMappingURL=List.js.map